<template>
  <div>
    <service-list-add-new
      :is-add-new-service-sidebar-active.sync="isAddNewServiceSidebarActive"
      :get-has-information="getHasInformation"
      :id="id"
      @refetch-data="refetchData"
      @show-message="showMessage"
    />
    <b-card no-body class="mb-0">

        <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->

          <b-col cols="12" class="mb-1">
            <h4 
              class="service-title" 
              @click="openTitleEditModal"
            >{{ service_title || `Services at ${store_name}` }}</h4>

          <feather-icon
            icon="EditIcon"
            size="16"
            class="cursor-pointer"
            @click="openTitleEditModal"
          />
          </b-col>

          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="handleAdd()"
              >
                <span class="text-nowrap">Add Service</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

        <b-table
          ref="refServiceListTable"
          class="position-relative"
          :items="fetchServices"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc">

        <template #cell(image)="data">
          <b-img
            rounded
            blank-color="#5A8DEE"
            alt="Rounded image"
            :src="data.item.image_url"
            class="d-inline-block mr-1 mb-1 display-image"
            @click="addImages(data.item.id)"
          />
        </template>
        
        <template #cell(has_information)="data">
          <feather-icon v-if="data.item.has_information" icon="CheckIcon" />
        </template>

        <template #cell(content)="data">
          <div v-html="data.item.content"></div>
        </template>

        <template #cell(is_active)="data">
          <feather-icon v-if="data.item.is_active" icon="CheckIcon" />
        </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item @click="editService(data.item.id)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>

              <b-dropdown-item @click="addImages(data.item.id)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Add Images</span>
              </b-dropdown-item>

              <b-dropdown-item @click="confirmDelete(data.item.id)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
         </template>
        </b-table>
        <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalServices"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-service-edit-title"
      title="Edit Service Title"
      ok-title="Save"
      cancel-variant="outline-secondary"
      @ok="handleTitleEdit"
      centered
    >
    <b-form-group label="Category">
        <b-form-input
          v-model="editingSlug"
          placeholder="Enter Category"
        />
      </b-form-group>
      <b-form-group label="Service Title">
        <b-form-input
          v-model="editingTitle"
          placeholder="Enter service title"
        />
      </b-form-group>
     
    </b-modal>

    <b-modal
      v-model="showImageModal"
      title="Service Images"
      size="lg"
      hide-footer
      centered
    >
      <b-overlay
        :show="imageLoading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <div class="gallery-grid">
          <div 
            v-for="image in serviceImages" 
            :key="image.id" 
            class="gallery-item"
          >
            <img :src="getServiceImage(image.image_path)" />
            <div class="gallery-item-actions">
              <b-button
                variant="danger"
                size="sm"
                @click="deleteServiceImage(image.id)"
              >
                Delete
              </b-button>
            </div>
          </div>
          
          <div class="gallery-upload">
            <el-upload
              ref="uploadRef"
              class="uploader"
              :action="`${uploadUrl}/${currentServiceId}/images`"
              :headers="headerObj"
              name="file"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :auto-upload="true"
            >
              <div class="upload-trigger">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                >
                  Upload Image
                </b-button>
              </div>
            </el-upload>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  BModal,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import axiosIns from "@/libs/axios";
import serviceStoreModule from "../serviceStoreModule";
import useServicesList from "./useServicesList";
import ServiceListAddNew from "./ServiceListAddNew.vue";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BImg,
    BModal,
    BOverlay,
    vSelect,
    ServiceListAddNew,
  },
  methods: {
    handleTitleEdit(bvModalEvent) {
      bvModalEvent.preventDefault()
      
      store.dispatch('bar-service/updateServiceTitle', {
        service_title: this.editingTitle,
        service_slug: this.editingSlug
      })
      .then(response => {
        this.showMessage(
          'Success',
          'Service title updated successfully',
          'CheckIcon',
          'success'
        )
        this.$bvModal.hide('modal-service-edit-title')
        this.refetchData()
      })
      .catch(error => {
        this.showMessage(
          'Fail',
          error.response.data.message,
          'HeartIcon', 
          'danger'
        )
      })
    },
    openTitleEditModal() {
      this.editingTitle = this.service_title || `Services at ${this.store_name}`
      this.editingSlug = this.service_slug || 'Services'
      this.$bvModal.show('modal-service-edit-title')
    },
    confirmDelete(id) {
      this.$swal({
        title: "Are you sure?",
        text: "Your action is final and you are not able to recover the data.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store
            .dispatch("bar-service/deleteService", id)
            .then((response) => {
              this.refetchData();
              this.showMessage(
                "Success",
                response.data.message,
                "CheckIcon",
                "success"
              );
            })
            .catch((error) => {
              this.showMessage(
                "Fail",
                error.response.data.message,
                "HeartIcon",
                "danger"
              );
            });
        }
      });
    },
    handleAdd() {
      this.id = 0;
      this.isAddNewServiceSidebarActive = true;
    },
    editService(id) {
      console.log(id);
      this.id = id;
      this.isAddNewServiceSidebarActive = true;
    },
    addImages(id) {
      this.currentServiceId = id
      this.showImageModal = true
      this.fetchServiceImages()
    },
    fetchServiceImages() {
      this.imageLoading = true
      store.dispatch('bar-service/fetchServiceImages', this.currentServiceId)
        .then(response => {
          this.serviceImages = response.data.images
        })
        .catch(error => {
          this.showMessage(
            'Error',
            'Failed to fetch images',
            'AlertTriangleIcon',
            'danger'
          )
        })
        .finally(() => {
          this.imageLoading = false
        })
    },
    handleUploadSuccess(response) {
    
        this.showMessage(
          'Success',
          'Image uploaded successfully',
          'CheckIcon',
          'success'
        )
        this.fetchServiceImages()
      
    },
    handleUploadError() {
      this.showMessage(
        'Error',
        'Failed to upload image',
        'AlertTriangleIcon',
        'danger'
      )
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.showMessage(
          'Error',
          'You can only upload image files!',
          'AlertTriangleIcon',
          'danger'
        )
      }
      return isImage
    },
    deleteServiceImage(imageId) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('bar-service/deleteServiceImage', {
            service_id: this.currentServiceId,
            image_id: imageId
          })
            .then(response => {
              this.showMessage(
                'Success',
                'Image deleted successfully',
                'CheckIcon',
                'success'
              )
              this.fetchServiceImages()
            })
            .catch(error => {
              this.showMessage(
                'Error',
                'Failed to delete image',
                'AlertTriangleIcon',
                'danger'
              )
            })
        }
      })
    }
  },
  data() {
    return {
      id: 0,
      editingTitle: '',
      editingSlug: '',
      showImageModal: false,
      imageLoading: false,
      serviceImages: [],
      currentServiceId: null,
      uploadUrl: process.env.VUE_APP_SERVICE_URL + '/service',
      headerObj: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
      }
    };
  },
  setup() {
    const BAR_GALLERY_STORE_MODULE_NAME = "bar-service";
    const isAddNewServiceSidebarActive = ref(false);

    if (!store.hasModule(BAR_GALLERY_STORE_MODULE_NAME))
      store.registerModule(BAR_GALLERY_STORE_MODULE_NAME, serviceStoreModule);

    onUnmounted(() => {
      if (store.hasModule(BAR_GALLERY_STORE_MODULE_NAME))
        store.unregisterModule(BAR_GALLERY_STORE_MODULE_NAME);
    });

    onMounted(() => {});

    const {
      fetchServices,
      tableColumns,
      perPage,
      currentPage,
      totalServices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refServiceListTable,
      refetchData,
      getServiceImage,
      showMessage,
      service_title,
      service_slug,
      store_name,
      getHasInformation
    } = useServicesList();

    return {
      //SideBar
      isAddNewServiceSidebarActive,

      fetchServices,
      tableColumns,
      perPage,
      currentPage,
      totalServices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refServiceListTable,
      refetchData,
      getServiceImage,
      showMessage,
      service_title,
      service_slug,
      store_name,
      getHasInformation
    };
  },
};
</script>

<style lang="scss" scoped>
.service-title {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  display: inline-block;
  text-decoration: underline;

}

.per-page-selector {
  width: 90px;
}


.display-image{
  max-width: 150px;
  height: auto;
  cursor: copy;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.gallery-item {
  position: relative;
  aspect-ratio: 1;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }

  .gallery-item-actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover .gallery-item-actions {
    opacity: 1;
  }
}

.gallery-upload {
  aspect-ratio: 1;
  border: 2px dashed #dcdfe6;
  display: flex;
  justify-content: center;
  align-items: center;

  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .upload-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    border-color: #7367f0;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

